// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TghW","textarea":"styles_textarea__2kiVr"};